import { BaseSchemes, NodeEditor, Root, Scope } from 'rete';
import { Area2D, Area2DInherited, AreaPlugin } from 'rete-area-plugin';
import { ClickStrategy } from './click-strategy';
import { DropStrategy } from './drop-strategy';
import { Strategy } from './strategy';

/**
 * Dock plugin pour Rete.js. Permet d'ajouter des noeuds au designer par drag&drop ou en cliquant sur une icone du dock.
 */
export class DockPlugin<Schemes extends BaseSchemes> extends Scope<never, Area2DInherited<Schemes>> {
    /**
     * Strategie à appliquer sur un clic souris.
     */
    clickStrategy!: Strategy;

    /**
     * Strategie à appliquer sur un glisser/deposer.
     */
    dropStrategy!: Strategy;

    /**
     * Constructeur.
     */
    constructor() {
        super('dock');
    }

    /**
     * Défini le parent du plugin.
     * @param scope
     */
    override setParent(scope: Scope<Area2D<Schemes>, [Root<Schemes>]>): void {
        super.setParent(scope);

        const area = this.parentScope<AreaPlugin<Schemes>>(AreaPlugin);
        const editor = area.parentScope<NodeEditor<Schemes>>(NodeEditor);

        this.clickStrategy = new ClickStrategy(editor, area);
        this.dropStrategy = new DropStrategy(editor, area);
    }

    /**
     * Ajoute la capacité de créer des noeuds dans le designer à un élément Html.
     * @param element : Element Html qui pourra être cliqué ou glisser/deposer pour créer un noeud.
     * @param create : Fonction appellée pour créer le noeud
     */
    addNodeCreationCapabilityToElement(element: HTMLElement, create: () => Schemes['Node']) {
        this.clickStrategy.addNodeCreationCapabilityToElement(element, create);
        this.dropStrategy.addNodeCreationCapabilityToElement(element, create);
    }
}
